import { useEffect, useState } from 'react';
import { myCompanyService } from '../../services/companies/myCompanyService.js';

export const useCompanyIcon = () => {
  const [iconUrl, setIconUrl] = useState('');

  useEffect(() => {
    let cancelled = false;
    let objectUrl = '';

    const loadIcon = async () => {
      try {
        const blob = await myCompanyService.getMyCompanyIcon();
        if (cancelled || !blob) return;

        objectUrl = URL.createObjectURL(blob);
        setIconUrl(objectUrl);
      } catch (error) {
        console.error('Error loading company icon:', error);
      }
    };

    loadIcon();

    return () => {
      cancelled = true;
      if (objectUrl) URL.revokeObjectURL(objectUrl);
    };
  }, []);

  return iconUrl;
};
